import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { StyledButton } from "./Filters.styled";

import Dropdown from "@components/common/Dropdown";
import {
  RecommendationScope,
  RecommendationState,
  RecommendationType,
} from "@type/Recommendation";
import { useRecommendationsStore } from "@store/recommendations";
import { Box, Stack, Divider } from "@components/base";

interface Component {}

const Component: FC<Component> = () => {
  const { t } = useTranslation();
  const { activeTab, filter, setFilter } = useRecommendationsStore();

  const handleClickScope = (scope: RecommendationScope): void => {
    setFilter({
      scopes: filter.scopes.includes(scope)
        ? filter.scopes.filter((s) => s !== scope)
        : [...filter.scopes, scope],
    });
  };

  const handleClickType = (type: RecommendationType): void => {
    setFilter(
      filter.types.includes(type)
        ? {
            types: filter.types.filter((t) => t !== type),
          }
        : {
            types: [...filter.types, type],
          },
    );
  };

  const handleClickState = (state: RecommendationState): void => {
    setFilter(
      filter.states.includes(state)
        ? {
            states: filter.states.filter((s) => s !== state),
          }
        : {
            states: [...filter.states, state],
          },
    );
  };

  return (
    <Stack direction="row" spacing={2}>
      {activeTab === "archive" && (
        <Stack spacing={1} direction="row">
          <StyledButton
            onClick={() => handleClickState("not-relevant")}
            variant={
              filter.states.includes("not-relevant") ? "contained" : "outlined"
            }
          >
            {t("recommendationsFilters.notRelevant")}
          </StyledButton>
          <StyledButton
            onClick={() => handleClickState("completed")}
            variant={filter.states.includes("completed") ? "contained" : "outlined"}
          >
            {t("recommendationsFilters.completed")}
          </StyledButton>
        </Stack>
      )}
      {activeTab !== "archive" && (
        <>
          <Box>
            <Dropdown<RecommendationScope>
              title={t("recommendationsFilters.scopes")}
              items={[
                {
                  label: t("recommendationsFilters.scope1"),
                  item: 1,
                },
                {
                  label: t("recommendationsFilters.scope2"),
                  item: 2,
                },
                {
                  label: t("recommendationsFilters.scope3"),
                  item: 3,
                },
              ]}
              onClickItem={handleClickScope}
              multiSelect
              selected={filter.scopes}
            />
          </Box>
          <Box>
            <Divider orientation="vertical" />
          </Box>
          <Stack spacing={1} direction="row">
            <StyledButton
              onClick={() => handleClickType("essential")}
              variant={filter.types.includes("essential") ? "contained" : "outlined"}
            >
              {t("recommendationsFilters.essential")}
            </StyledButton>
            <StyledButton
              onClick={() => handleClickType("base")}
              variant={filter.types.includes("base") ? "contained" : "outlined"}
            >
              {t("recommendationsFilters.advanced")}
            </StyledButton>
            <StyledButton
              onClick={() => handleClickType("industry_specific")}
              variant={
                filter.types.includes("industry_specific") ? "contained" : "outlined"
              }
            >
              {t("recommendationsFilters.industry")}
            </StyledButton>
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default Component;
